<script>
import Multiselect from "vue-multiselect";
import VueIconPicker from "@components/vue-icon-picker";
import { appSectionsMethods } from "@state/helpers";
import { ValidationProvider, ValidationObserver } from "vee-validate";
let _ = require("lodash");
import { Money } from "v-money";
export default {
  name: "CuoponTypesCreateForm",
  components: { Multiselect, Money, "vue-icon-loader": VueIconPicker },
  props: {
    onFormSubmit: {
      type: Function,
      required: true,
    },
    newItem: {
      type: Object,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
    },
  },
  data() {
    return {
      icon: { name: "", type: "fontawesome", color: "#000000" },
      appSectionsOptions: [],
      appSectionsOptionsCache: [],
      appSectionsOptionsMounted: false,
      loadingAppSectionsOptions: false,
      randomId: Math.random(),

      fields: [
        {
          key: "name",
          label: "labels.templateVariables.$name",
          size: 7,
          type: "text",
          validations: { required: true },
        },
        {
          key: "init_ejecution_task_date",
          label: "labels.templateVariables.$init_ejecution_task_date",
          size: 6,
          type: "date",
          validations: { required: true },
        },
        {
          key: "end_ejecution_task_date",
          label: "labels.templateVariables.$end_ejecution_task_date",
          size: 6,
          type: "date",
          validations: { required: true },
        },
        {
          key: "time_to_claim_months",
          label: "labels.templateVariables.$time_to_claim_months",
          size: 4,
          type: "number",
          validations: { required: true, min_value: 0, numeric: true },
        },
        // {
        //   key: "periodicity_generation_days",
        //   label: "labels.templateVariables.$periodicity_generation_days",
        //   size: 4,
        //   type: "number",
        //   validations: { required: true, numeric: true, min_value: 0 },
        // },
        {
          key: "periodicity_generation_months",
          label: "labels.templateVariables.$periodicity_generation_months",
          size: 4,
          type: "number",
          validations: { required: true, numeric: true, min_value: 0 },
        },
        {
          key: "antiquity_condition_months",
          label: "labels.templateVariables.$antiquity_condition_months",
          size: 4,
          type: "number",
          validations: { required: true, numeric: true, min_value: 0 },
        },
        {
          key: "time_to_ejecution_weeks",
          label: "labels.templateVariables.$time_to_ejecution_weeks",
          size: 4,
          type: "number",
          validations: { required: true, numeric: true, min_value: 0 },
        },
        {
          key: "time_to_ejecution_months",
          label: "labels.templateVariables.$time_to_ejecution_months",
          size: 4,
          type: "number",
          validations: { required: true, numeric: true, min_value: 0 },
        },

        {
          key: "amount",
          label: "labels.templateVariables.$amount",
          size: 3,
          type: "money",
          validations: { required: true, min_value: 1000 },
        },
      ],
      labels: {
        "es-ES": {
          labelPrevDecade: "Década anterior",
          labelPrevYear: "Año anterior",
          labelPrevMonth: "Mes anterior",
          labelCurrentMonth: "Mes actual",
          labelNextMonth: "El próximo mes",
          labelNextYear: "El año que viene",
          labelNextDecade: "Próxima década",
          labelToday: "Hoy",
          labelSelected: "Fecha seleccionada",
          labelNoDateSelected: "No se seleccionó ninguna fecha",
          labelCalendar: "Calendario",
          labelNav: "Navegación por calendario",
          labelHelp: "Usa las teclas de flecha para navegar por el calendario",
        },
      },
    };
  },
  watch: {},
  mounted() {
    console.log(this.newItem);
  },
  methods: {
    async submitFormCreate() {
      console.log("entre");
      const isValid = await this.$refs.observer.validate();
      const errors = Object.values(this.$refs.observer.errors).flat();
      if (!isValid) {
        this.$generate_noty(
          "danger",
          this.$t("forms.form_errors", { errors: errors.length }),
          this.$t("alerts.error"),
          5000,
          true
        );

        return;
      } else {
        this.onFormSubmit();
      }
    },
    closeModal() {
      this.$emit("close");
    },
    datePastDisabled(ymd, date) {
      let actualDate = new Date();
      actualDate = actualDate.getTime();
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const day = new Date(ymd).getTime();
      // Return `true` if the date should be disabled
      return actualDate > day;
    },
  },
};
</script>
<template>
  <ValidationObserver ref="observer" @submit.prevent="submitFormCreate">
    <b-form ref="createform">
      <b-row>
        <b-col v-for="item in fields" :key="item.key" :md="item.size">
          {{ $t(item.label) }}:
          <ValidationProvider
            v-slot="validationContext"
            :name="item.key + '|' + randomId"
            :rules="item.validations"
          >
            <b-form-input
              v-if="item.type === 'text' || item.type === 'number'"
              v-model="newItem[item.key]"
              :type="item.type"
              :name="item.key + '|' + randomId"
              class="mt-1"
              :placeholder="$t(item.label)"
            />
            <money
              v-else-if="item.type === 'money'"
              v-model="newItem[item.key]"
              class="form-control"
            />
            <b-input-group class="" v-else-if="item.type === 'date'">
              <b-form-input
                v-model="newItem[item.key]"
                type="text"
                placeholder="DD-MM-YY"
                autocomplete="off"
                v-mask="'##-##-####'"
              ></b-form-input>
              <b-input-group-append :key="Math.random()">
                <b-form-datepicker
                  v-model="newItem[item.key]"
                  :date-disabled-fn="datePastDisabled"
                  button-only
                  right
                  no-flip
                  locale="es-ES"
                  size="sm"
                  :start-weekday="0"
                  :show-decade-nav="true"
                  v-bind="labels['es-ES'] || {}"
                  :hide-header="true"
                ></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
            <!-- <Multiselect
                v-else-if="item.type === 'select' || item.type === 'multiselect'"
                v-model="newItem[item.key]"
                :multiple="item.type === 'multiselect' ? true : false"
                :name="item.key + '|' + randomId"
                :options="item.options.map((x) => ({ id: x._id, text: x.id }))"
                label="text"
                track-by="id"
                :loading="isSubmitting"
                :internal-search="true"
                select-label="✚"
                selected-label="✓"
                deselect-label="✖"
                :showNoResults="true"
                :showNoOptions="true"
                :placeholder="$t('multiselect.placeholder', { field: $t(item.label) })"
              >
                <span slot="noOptions">{{ $t("multiselect.no_options") }}</span>
                <span slot="noResult">{{ $t("multiselect.no_result") }}</span>
              </Multiselect> -->
            <b-form-invalid-feedback :state="validationContext.errors.length === 0">
              {{ validationContext.errors.join(". ") }}
            </b-form-invalid-feedback>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-card-footer class="bg-transparent p-0 mt-3">
        <b-button size="sm" variant="secondary" @click="closeModal">
          {{ $t("Cancelar") }}
        </b-button>
        <b-button
          type="button"
          @click="submitFormCreate"
          size="sm"
          variant="primary"
          :disabled="isSubmitting"
          class="ml-1"
        >
          <span v-if="!isSubmitting">
            {{ newItem.id ? $t("Editar") : $t("Crear") }}
          </span>
          <b-spinner
            v-if="isSubmitting"
            small
            label="Spinning"
            variant="light"
          ></b-spinner>
        </b-button>
      </b-card-footer>
    </b-form>
  </ValidationObserver>
</template>
